import React, { useLayoutEffect, useState, useRef } from "react";
import { logoMarquee } from "../../constants/logoMarquee";
import "./logoMarquee.css";

const LogoMarquee = () => {
  const marqueeRef = useRef(null);
  const [duration, setDuration] = useState(20);

  // useLayoutEffect prevents layout flashes by running synchronously before paint
  useLayoutEffect(() => {
    const marqueeElement = marqueeRef.current;

    if (marqueeElement) {
      // Calculate continuous speed context dynamically based on content width
      const contentWidth = marqueeElement.scrollWidth / 2;
      const speed = 100; // Pixels per second
      const calculatedDuration = contentWidth / speed;
      setDuration(calculatedDuration);
    }
  }, []);

  return (
    <div className="logoMarquee__container">
      <div
        className="logoMarquee__content"
        ref={marqueeRef}
        style={{ animationDuration: `${duration}s` }}
      >
        {/* Track Item Set 1 */}
        {logoMarquee.map((logo, index) => (
          <div
            key={`${logo.name || "logo"}-set1-${index}`}
            className="marquee-item"
          >
            <img src={logo.imgUrl} alt={`${logo.name || "partner"} logo`} />
          </div>
        ))}

        {/* Track Item Set 2 (Identical mirror array for seamless loop) */}
        {logoMarquee.map((logo, index) => (
          <div
            key={`${logo.name || "logo"}-set2-${index}`}
            className="marquee-item"
          >
            <img src={logo.imgUrl} alt={`${logo.name || "partner"} logo`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoMarquee;
